SsNodes = LP.module 'SsNodes'
StateStandards = LP.module 'StateStandards'

SsNodes.search = ->
  LP.module('Popovers').init()
  SsNodes.closePopoversOnOutsideClick()
  StateStandards.initSearchWidget()

SsNodes.index = SsNodes.search
SsNodes.show = ->
  SsNodes.search()
  $('.standard .btn-link').click ->
    $(@).text(if $(@).text() == 'see more' then 'see less' else 'see more')

SsNodes.closePopoversOnOutsideClick = ->
  $(document).on 'click', (e) ->
    $('[data-original-title]').each ->
      if !$(this).is(e.target) and $('.popover').has(e.target).length == 0
        $(this).popover('hide').data('bs.popover').inState.click = false
